import { EFonts } from 'libs/styles/styling';
import { useAnalytics } from 'libs/utils/site/analytics';
import { useState } from 'react';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    couponCode: string;
}

export const Temp_ItaliaTourCard = (props: Props): JSX.Element => {
    const analytics = useAnalytics();
    const [revealed, setRevealed] = useState(false);

    return (
        <S_Temp_ItaliaTourCard className={props.className}>
            {revealed ? (
                <S_Text>{props.couponCode}</S_Text>
            ) : (
                <S_Button
                    onClick={() => {
                        setRevealed(true);
                        analytics.track('event_ui.coupon_code_revealed', {
                            couponCode: props.couponCode
                        });
                    }}
                >
                    View Coupon Code
                </S_Button>
            )}
        </S_Temp_ItaliaTourCard>
    );
};

const S_Temp_ItaliaTourCard = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin: 20px 0 10px 0;
    justify-content: center;
`;

const S_Button = styled.div`
    cursor: pointer;
    display: flex;
    background-color: #ffce00;
    color: #000;
    border: 1px solid #000;
    width: 250px;
    height: 60px;
    text-align: center;
    justify-content: center;
    border-radius: 5px;
    line-height: 60px;
    font-size: 20px;
    font-family: ${EFonts.Bold};
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
`;

const S_Text = styled.div`
    background-color: #ffce00;
    color: #000;
    border: 1px dashed #000;
    width: 250px;
    height: 60px;
    text-align: center;
    justify-content: center;
    display: flex;
    border-radius: 5px;
    line-height: 60px;
    font-size: 30px;
    font-family: ${EFonts.Bold};
`;

// const S_TextUnder = styled.div`
//     font-size: 12px;
//     margin-top: 5px;
//     text-align: center;
//     width: 300px;
//     margin-left: auto;
//     margin-right: auto;
// `;
